module.exports = require("./ff-Latn-GM");